import { render, staticRenderFns } from "./GameRecordMyView.vue?vue&type=template&id=54fa6ef3&scoped=true"
import script from "./GameRecordMyView.vue?vue&type=script&lang=js"
export * from "./GameRecordMyView.vue?vue&type=script&lang=js"
import style0 from "./GameRecordMyView.vue?vue&type=style&index=0&id=54fa6ef3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa6ef3",
  null
  
)

export default component.exports